"use strict";
exports.__esModule = true;
exports.EMPLOYMENT = void 0;
var EMPLOYMENT = {
    BASIS: {
        FULL_TIME: 'full_time',
        PART_TIME: 'part_time',
        CONTRACT: 'contract',
        CASUAL: 'casual',
        TEMPORARY: 'temporary',
        UNKNOWN: 'unknown'
    },
    NATURE: {
        SALARY: 'salary',
        SELF_EMPLOYED: 'self_employed',
        STUDENT: 'student',
        RETIRED: 'retired',
        UNEMPLOYED: 'unemployed',
        HOME_DUTIES: 'home_duties',
        UNKNOWN: 'unknown'
    },
    ROLE_TYPE: {
        AGRICULTURAL_MANAGER: 'agricultural_manager',
        ARTS_OR_MEDIA_PROFESSIONAL: 'arts_or_media_professional',
        ADMIN_WORKER: 'admin_worker',
        COMMUNITY_WORKER: 'community_worker',
        CONSTRUCTION_MANAGER: 'construction_manager',
        DESIGNER_ENGINEER_SCIENTIST: 'designer_engineer_scientist',
        HEALTH_WELFARE_WORKER: 'health_or_welfare_worker',
        BUSINESS_PROFESSIONAL: 'finance_or_business_professional',
        FINANCE_BUSINESS_MARKETING_TECHNOLOGY_MANAGER: 'finance_business_marketing_or_technology_manager',
        HOSPITAL_WORKER: 'hospital_worker',
        LABOURER: 'labourer',
        LEGAL_PROFESSIONAL: 'legal_professional',
        MACHINERY_OPERATOR: 'machinery_operator',
        MARKETING_COMMUNICATION_PROFESSIONAL: 'marketing_or_communication_professional',
        OTHER: 'other',
        PROFESSOR_TEACHER_EDUCATION_WORKER: 'professor_teacher_education_worker',
        REAL_ESTATE_OR_INSURANCE_AGENT: 'real_estate_or_insurance_agent',
        RETAIL_OR_HOSPITALITY_MANAGER: 'retail_or_hospitality_manager',
        SALES_REPRESENTATIVE: 'sales_representative',
        SPORTS_PROFESSIONAL: 'sports_professional',
        TECHNOLOGY_PROFESSIONAL: 'technology_professional',
        TRADES_PERSON: 'trades_person',
        UNKNOWN: 'unknown'
    }
};
exports.EMPLOYMENT = EMPLOYMENT;
